/** @format */

import * as f from 'firebase/auth'

import { developMenu } from '../constants'

export const getCurrentProvider = (type) => new f[`${type}AuthProvider`]()

export const authPromiseHandler = (dispatch, promise, actions) =>
  promise
    .then(({ user }) => {
      const { displayName, stsTokenManager, email, emailVerified, photoURL, uid } = user

      dispatch(
        actions.success({
          displayName,
          stsTokenManager,
          email,
          emailVerified,
          photoURL,
          uid,
        }),
      )
      localStorage.setItem('accessToken', stsTokenManager.accessToken)
      localStorage.setItem('refreshToken', stsTokenManager.refreshToken)
      localStorage.setItem('uid', uid)
      window.history.pushState(null, null, '/')
    })
    .catch((error) => dispatch(actions.error(error)))

export const getCurrentMenu = (pathname) => {
  const isHtml = pathname.includes('html')
  const isJavascript = pathname.includes('js')
  const isReact = pathname.includes('react')
  const isRedux = pathname.includes('redux')
  const isGit = pathname.includes('git')

  if (isHtml) return developMenu.html
  if (isJavascript) return developMenu.js
  if (isReact) return developMenu.react
  if (isRedux) return developMenu.redux
  if (isGit) return developMenu.git

  return []
}
